import { render, staticRenderFns } from "./secondaryOrder.vue?vue&type=template&id=2acec246&"
import script from "./secondaryOrder.vue?vue&type=script&lang=js&"
export * from "./secondaryOrder.vue?vue&type=script&lang=js&"
import style0 from "./secondaryOrder.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "secondaryOrder.vue"
export default component.exports